import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vorna_token", data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-vorna-bg flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10"><Logo imgClass="h-14" className="justify-center" /><p className="mt-3 text-xs tracking-[0.35em] text-white/40 uppercase">Admin Console</p></div>
        <form onSubmit={submit} className="border border-white/10 p-8 space-y-5">
          <div>
            <label className="text-[11px] tracking-widest text-white/40 uppercase mb-2 block">Email</label>
            <Input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none border-white/15 bg-transparent h-12 focus-visible:ring-0 focus-visible:border-vorna-accent" />
          </div>
          <div>
            <label className="text-[11px] tracking-widest text-white/40 uppercase mb-2 block">Password</label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-white/15 bg-transparent h-12 focus-visible:ring-0 focus-visible:border-vorna-accent" />
          </div>
          <button data-testid="admin-login-submit" disabled={loading}
            className="w-full bg-vorna-accent py-3.5 font-display uppercase tracking-widest text-sm hover:bg-vorna-accentHover active:scale-95 transition-all flex items-center justify-center gap-2 disabled:opacity-60">
            <Lock className="h-4 w-4" /> {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
